import { useContext, useCallback } from 'react';
import { generateReplyEditorId } from '../../utils';
import { CommentContext } from '../../CommentContext';
/**
 * Every prop a reply comment box needs. Pass the returned props to your own `CommentBox` version and you're good to go!
 *
 * Returns `onPublishSuccess`, `onCancel`, and `id`
 *
 * Note: `onPublishSuccess` is usually passed directly to the CommentBoxSkeleton, but `onCancel` needs to be passed wherever you have your `useCommentCancelAction` is at.
 */ export function useReplyCommentBoxBase({ onPublishSuccess , onCancel  } = {}) {
    const { comment , setEditingState  } = useContext(CommentContext);
    const onCloseEditor = useCallback(()=>{
        setEditingState('none');
        onCancel && onCancel();
    }, [
        setEditingState,
        onCancel
    ]);
    const onReplyDone = useCallback((result)=>{
        setEditingState('none');
        onPublishSuccess && result.comment && onPublishSuccess(result);
    }, [
        onPublishSuccess,
        setEditingState
    ]);
    return {
        id: generateReplyEditorId(comment),
        onCancel: onCloseEditor,
        onPublishSuccess: onReplyDone
    };
}
